<template>
  <b-navbar
    toggleable="lg"
    :variant="getLayoutNavbarBg()"
    class="layout-navbar align-items-lg-center container-p-x"
  >
    <!-- Brand demo (see demo.css) -->
    <b-navbar-brand to="/" class="app-brand demo showicon d-lg-none py-0 mr-4">
      <span class="app-brand-logo demo bg-primary">
        <img src="../../public/vendor/img/logo.png" alt="" />
      </span>
      <span class="app-brand-text demo font-weight-normal ml-2">{{
        $t("m.header.navbar.APP_TITLE")
      }}</span>
    </b-navbar-brand>
    <!-- <b-breadcrumb style="margin-bottom: 0px;" class="align-items-lg-center ml-auto" :items="items1"/> -->
    <!-- Sidenav toggle (see demo.css) -->
    <b-navbar-nav
      class="layout-sidenav-toggle d-lg-none align-items-lg-center mr-4"
      v-if="sidenavToggle"
    >
      <a
        class="nav-item nav-link px-0 mr-lg-4"
        href="javascript:void(0)"
        @click="toggleSidenav"
      >
        <i class="ion ion-md-menu text-large align-middle" />
      </a>
    </b-navbar-nav>
    <div class="breadcrumb_mar mr-auto">
      <el-breadcrumb class="app-breadcrumb" separator="/">
        <el-breadcrumb-item
          v-for="(item, index) in levelList"
          :key="item.path"
          v-if="item.meta.title"
        >
          <router-link :to="item.path">{{ item.meta.title }}</router-link>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>

    <b-collapse is-nav id="app-layout-navbar">
      <!-- Divider -->
      <!-- <hr class="d-lg-none w-100 my-2"> -->
      <b-navbar-nav class="align-items-lg-center b-nav-height ml-auto">
        <!-- <div style="margin-right: 10px; width: 150px;">
          <multiselect
            v-model="currentshop"
            :options="shops"
            :searchable="false"
            :show-labels="false"
            :custom-label="shopname"
            placeholder="请选择店铺"/>
        </div> -->
        <!-- <div>
          <img :src="imgsrc" alt="">
        </div> -->
        <!-- 店铺 -->
        <el-select
          class="seleborder"
          popper-class="sele-option"
          @change="seleShop"
          v-model="shopvalue"
          :placeholder="$t('m.content.common.SELECT')"
        >
          <template slot="prefix" class="tem-img"
            ><img :src="imgsrc" alt=""
          /></template>
          <template slot="prefix">
            <div class="tem-text">{{ region_name }}</div>
          </template>
          <el-option
            class="sele-shop"
            v-for="item in shops"
            :key="item.id"
            :label="item.name"
            :value="item"
          >
            <img :src="item.logoImg" alt=" " />
            <div class="sele-name ml-2">
              <p style="margin: 0px; color: rgb(132, 146, 166)">
                {{ item.name }}
              </p>
              <p
                style="
                  margin: 0px;
                  color: rgb(132, 146, 166);
                  font-size: 13px;
                  margin: 0px;
                "
              >
                {{ item.region_name }}
              </p>
            </div>
          </el-option>
        </el-select>
        <!-- 语言 -->
        <b-nav-item-dropdown class="demo-navbar-user">
          <template slot="button-content">
            <span
              class="d-inline-flex flex-lg-row-reverse align-items-center align-middle"
            >
              <span
                v-if="this.lang_name == '日本语'"
                style="margin-right: 5px !important"
                class="mr-lg-2 ml-2 ml-lg-0"
                ><img
                  src="../../public/vendor/img/icon_JP@2x.png"
                  class="langImg mr_75 mr-2"
                  alt=""
                />{{ lang_name }}</span
              >
              <span
                v-if="this.lang_name == '简体中文'"
                style="margin-right: 5px !important"
                class="mr-lg-2 ml-2 ml-lg-0"
                ><img
                  src="../../public/vendor/img/icon_cn@2x.png"
                  class="langImg mr_75 mr-2"
                  alt=""
                />{{ lang_name }}</span
              >
            </span>
          </template>

          <b-dd-item @click="selected('ja')"
            ><img
              src="../../public/vendor/img/icon_JP@2x.png"
              class="langImg"
              alt=""
            />
            &nbsp; {{ $t("m.content.common.JAPAN_LANGUAGE") }}</b-dd-item
          >
          <b-dd-item @click="selected('zh')"
            ><img
              src="../../public/vendor/img/icon_cn@2x.png"
              class="langImg"
              alt=""
            />
            &nbsp; {{ $t("m.content.common.CHINESE_LANGUAGE") }}</b-dd-item
          >
        </b-nav-item-dropdown>
        <!-- 个人中心 -->
        <span
          class="d-inline-flex flex-lg-row-reverse align-items-center align-middle"
        >
          <span
            class="px-1 mr-lg-2 ml-2 ml-lg-0"
            style="cursor: pointer"
          ></span>
          <b-nav-item-dropdown class="demo-navbar-user">
            <template slot="button-content">
              <span
                class="d-inline-flex flex-lg-row-reverse align-items-center align-middle"
              >
                <span class="px-1 mr-lg-2 ml-2 ml-lg-0">{{ user }}</span>
              </span>
            </template>

            <b-dd-item v-on:click="upMsg"
              ><i class="ion ion-ios-person text-lightest"></i>&nbsp;
              {{ $t("m.content.pushes.PERSON_INFORMATION") }}</b-dd-item
            >
            <b-dd-divider />
            <b-dd-item v-on:click="logout"
              ><i class="ion ion-ios-log-out text-danger mr-2"></i
              >{{ $t("m.header.navbar.LOGOUT") }}</b-dd-item
            >
          </b-nav-item-dropdown>
          <span class="px-1 mr-lg-2 ml-2 ml-lg-0 cp"></span>
        </span>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<style
  src="@/vendor/libs/vue-multiselect/vue-multiselect.scss"
  lang="scss"
></style>

<script>
import { SweetModal } from "sweet-modal-vue";

import axios from "axios";
import Multiselect from "vue-multiselect";
import { getShopList } from "../api/login";
import { getMeDetail } from "../api/role";

export default {
  inject: ["reload"],

  props: {
    sidenavToggle: {
      type: Boolean,
      default: true,
    },
  },

  components: {
    Multiselect,
    SweetModal,
  },

  data: () => ({
    user: localStorage.getItem("user"),
    id: localStorage.getItem("shopid"),
    items1: [{ text: "", active: true }],
    levelList: null,

    /* options: [
          {value: 'ja', text: '日本语'},
        {value: 'zh', text: '简体中文'},
      ], */
    shops: [],
    currentshop: JSON.parse(localStorage.getItem("shopdata")),
    shopvalue: "",
    imgsrc: "",
    addre_dispaly: "",
    region_name: "",
    lang_code: "",
  }),
  watch: {
    $route() {
      this.getBreadcrumb();
    },
    /* selected:function(){
        this.$i18n.locale = this.selected
        if(this.selected == 'ja'){
          localStorage.lastname = 'ja'
        }else{
          localStorage.lastname = 'zh'
        }
      }, */
    /* currentshop:function(){

        if(this.currentshop === null){
          this.currentshop = JSON.parse(localStorage.getItem('shopdata'));
          this.$message.warning('已在所选店铺');
          return;
        }

        if(this.currentshop.id == localStorage.getItem('shopid')){
          this.$message.warning('已在所选店铺');
          return;
        }

        getMeDetail().then(resp =>{
          if(resp.success){
            if(resp.data.role && resp.data.role.role){
              let userRole = resp.data.role.role.permissions;

              userRole.forEach(this.makeActionTitle);

              let groups = this.groupBy(userRole, function(item){
                return item.name;
              });

              localStorage.setItem('role', JSON.stringify(groups));

              this.reload();

            }
          }
        })
        
      } */
  },

  created() {
    this.shopvalue = this.currentshop.name;
    if (localStorage.getItem("lastname")) {
      this.selected(localStorage.getItem("lastname"));
    } else {
      localStorage.setItem("lastname", "ja");
      this.lang_name = "日本语";
      this.selected("ja");
    }
    this.getShops();
    this.getBreadcrumb();
  },

  methods: {
    shopname({ name }) {
      return `${name}`;
    },
    getBreadcrumb() {
      let matched = this.$route.matched.filter((item) => item.name);

      const first = matched[0];

      if (this.lang_code == "zh") {
        first.parent.meta.title = first.parent.meta.zhtitle;
        first.meta.title = first.meta.zhtitle;
        var titleText = "首页";
      } else {
        first.parent.meta.title = first.parent.meta.jatitle;
        first.meta.title = first.meta.jatitle;
        var titleText = "インデックス";
      }

      if (first.meta.title != first.parent.meta.title) {
        matched.unshift(first.parent); // 相等说明是列表路由
      }

      if (first && first.name !== "dashboard") {
        matched = [{ path: "/dashboard", meta: { title: titleText } }].concat(
          matched
        );
      }

      this.levelList = matched;
    },

    groupBy(array, f) {
      let groups = {};
      array.forEach(function (o) {
        let group = o.name;
        groups[group] = groups[group] || {};
        let role = o ? o.des : null;
        groups[group][role] = o.slug;
      });
      return groups;
    },

    makeActionTitle(e, i) {
      let pair = e.slug.split(":");
      e.index = i;
    },

    getShops() {
      let that = this;
      getShopList().then((resp) => {
        if (resp.success) {
          this.shops = resp.data;
          this.shops.map((data) => {
            if (that.shopvalue == data.name) {
              if (data.logo && data.logo.src) {
                that.imgsrc = data.logo.url + data.logo.src;
              }
              if (data.address) {
                that.addre_dispaly = data.address[0].address;
              }
              that.region_name = that.utils.regionStr(data);
              console.log(that.region_name);
            }
            if (data.logo && data.logo.src) {
              data.logoImg = data.logo.url + data.logo.src;
            }
            data.region_name = that.utils.regionStr(data);
          });
        }
      });
    },

    seleShop(value) {
      var _this = this;
      let oldShopId = localStorage.getItem("shopid");
      this.$confirm(
        this.$t("m.content.common.CHANGE_SHOP"),
        this.$t("m.content.common.TIP"),
        {
          confirmButtonText: this.$t("m.content.common.SURE"),
          cancelButtonText: this.$t("m.content.common.CANCEL"),
          type: "warning",
        }
      )
        .then(() => {
          localStorage.setItem("shopid", value.id);
          getMeDetail().then((resp) => {
            if (resp.success) {
              if (resp.data.role && resp.data.role.role) {
                let userRole = resp.data.role.role.permissions;
                userRole.forEach(_this.makeActionTitle);
                let groups = _this.groupBy(userRole, function (item) {
                  return item.name;
                });
                localStorage.setItem("role", JSON.stringify(groups));
              }
              localStorage.shopdata = JSON.stringify(value);
              localStorage.shopid = value.id;
              //_this.reload();
              location.href = "/dashboard";
              this.$message({
                type: "success",
                message: this.$t("m.content.common.SUCCESSFUL_OPERASTION"),
              });
            } else {
              localStorage.setItem("shopid", oldShopId);
            }
          }); /*.catch(() => {
            localStorage.setItem('shopid', oldShopId)
          })*/
        })
        .catch(() => {
          /* this.$message({
            type: 'info',
            message: this.$t("m.content.common.CANCEL_CHANGE")
          });  */
          localStorage.setItem("shopid", oldShopId);
          _this.shopvalue = value.name;
        });
    },

    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },

    getLayoutNavbarBg() {
      return this.layoutNavbarBg;
    },
    upMsg() {
      this.$router.push({
        name: "meDetail",
        query: { id: this.id },
      });
    },
    logout() {
      localStorage.clear();
      this.$router.push("/merchant_admin");
    },
    selected(code) {
      this.$i18n.locale = code;
      if (code == "ja") {
        localStorage.setItem("lastname", "ja");
        this.lang_name = "日本语";
        this.resetSetItem("data", "ja");
      } else {
        localStorage.setItem("lastname", "zh");
        this.lang_name = "简体中文";
        this.resetSetItem("data", "zh");
      }
      this.lang_code = code;
      this.getBreadcrumb();
    },
  },
};
</script>
<style lang="scss">
// .navbar{
//   padding:1rem 1rem;
// }
.navbar {
  padding: 10px;
}
.showicon {
  display: none;
}
.showicon .app-brand-logo .demo {
  display: none !important;
}
.cp {
  cursor: pointer;
}
.langImg {
  width: 18px;
  height: 18px;
}
.sele-shop {
  display: flex;
  align-items: center;
}
.align-items-lg-center .el-select {
  display: inline-block;
  position: relative;
  // width: 200px;
}
.sele-shop img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  vertical-align: middle;
}
.sele-option .el-select-dropdown__item {
  height: 50px !important;
  line-height: 18px !important;
}

.sele-option .el-select-dropdown__item.selected {
  font-weight: 500 !important;
  color: none !important;
}
.sele-option {
  top: 48px !important;
}

/* 弹框 */
// .el-button{
//     outline: 0 !important;
//     background-color: #409EFF !important;
// }
// /*面包屑 */
.app-breadcrumb .el-breadcrumb__inner a:hover {
  color: #26b4ff;
}
.mr_75 {
  margin-right: 0.75rem;
}
@media screen and (max-width: 480px) {
  .el-breadcrumb {
    margin-left: 0px;
    margin-top: 0px;
  }
  .app-brand-text {
    display: none;
  }

  .breadcrumb_mar {
    float: left;
  }
}
.el-button {
  outline: 0 !important;
  // background-color: #409EFF !important;
}
.seleborder .el-input__prefix {
  left: -15px !important;
  /* top: 4px !important; */
}

.seleborder .el-input__prefix img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.tem-text {
  position: absolute;
  top: 18px;
  left: 45px;
  width: 100px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  font-size: 12px;
  color: #a3a4a6;
}
.seleborder .el-input__inner {
  border: none !important;
  color: #a3a4a6;
  height: 20px;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
}
.seleborder .el-input .el-select__caret.is-reverse {
  /* -webkit-transform: rotateZ(0); */
  transform: rotateZ(180deg) !important;
}
.seleborder .el-input__icon {
  height: auto;
  line-height: 1;
}
@media screen and (max-width: 992px) {
  .b-nav-height .el-select {
    height: 40px;
    margin-left: 22px;
  }
}
</style>
